import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

function getAuthTokenFromCookie(): string | null {
  const match = document.cookie.match(/(^|;\s*)_auth=([^;]+)/);
  return match ? decodeURIComponent(match[2]) : null;
}

function buildHeaders(token?: string | null) {
  const t = token ?? getAuthTokenFromCookie();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function fetchUserLanguage(
  token?: string
): Promise<string | null> {
  try {
    const res = await axios.get(`${API_BASE}/users/language/`, {
      headers: buildHeaders(token),
    });
    return res.data.language ?? null;
  } catch (err) {
    console.error('Could not load the preferred language:', err);
    return null;
  }
}

export async function saveUserLanguage(
  language: string,
  token?: string
): Promise<boolean> {
  try {
    await axios.post(
      `${API_BASE}/users/set-language/`,
      { language },
      { headers: buildHeaders(token) }
    );
    return true;
  } catch (err) {
    console.error('Was not able to save preferred language:', err);
    return false;
  }
}
